/** How many documents are allowed to be uploaded as a property creation method */
export const maxDocFilesInputCount = 3;
